import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Icon } from 'components/atoms'
import { FormattedMessage } from 'react-intl'

const WidgetFacebook = ({ numberOfReviews, stars }) => (
  <Widget
    href="https://www.facebook.com/pg/Caldeira-Guesthouse-Surfcamp-501176026704572/reviews/"
    title="Facebook.com - Caldeira Guesthouse & Surfcamp"
    target="_blank"
    rel="noopener noreferrer"
  >
    <Widget.Initial>
      <Widget.Score>
        <Icon icon="star" height={14} modifiers="inverse" /> {stars}
      </Widget.Score>
    </Widget.Initial>
    <Widget.End>
      <Widget.Reviews>
        <Logo />
        <Widget.Comments>{`${ numberOfReviews } `}
          <FormattedMessage id="comments" />
        </Widget.Comments>
      </Widget.Reviews>
    </Widget.End>
  </Widget>
)

WidgetFacebook.propTypes = {
  numberOfReviews: PropTypes.number.isRequired,
  stars: PropTypes.number.isRequired
}

const Widget = styled.a`
  display: inline-flex;
  padding: ${ props => props.theme.spacing.xxms };
  align-items: center;
  transition: background-color 0.1s ease-out;
  border-radius: ${ props => props.theme.value.borderRadius };

  text-decoration: none;
  color: ${ props => props.theme.color.base };

  &:hover {
    background-color: ${ props => props.theme.color.bg };
    cursor: pointer;
  }
`

Widget.Initial = styled.div`
  padding-right: ${ props => props.theme.spacing.xs };
  svg {
    height: 36px;
  }
`

Widget.End = styled.div`
  display: flex;
`

Widget.Score = styled.div`
  font-size: ${ props => props.theme.size.xs };
  color: ${ props => props.theme.color.baseInverse };
  padding: ${ props => props.theme.spacing.xxs };
  background-color: ${ props => props.theme.color.facebook };
  border-radius: ${ props => props.theme.value.borderRadius };
  font-weight: ${ props => props.theme.weight.medium };
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    margin-right: ${ props => props.theme.spacing.xxxs };
  }
`

Widget.Reviews = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  padding-right: ${ props => props.theme.spacing.xs };
  svg {
    margin-bottom: ${ props => props.theme.spacing.xxxs };
  }
`

Widget.Text = styled.span`
  color: ${ props => props.theme.color.booking };
  font-weight: 500;
`

Widget.Comments = styled.span`
  color: ${ props => props.theme.color.baseLigther };
  font-size: ${ props => props.theme.size.xxs };
  white-space: nowrap;
`

const Logo = () => (
  <svg
    width="67"
    height="14"
    viewBox="0 0 67 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.643 6.872c-.568 0-.977.186-1.392.375v4.291c.398.038.625.038 1.003.038 1.362 0 1.549-.624 1.549-1.495v-2.05c0-.643-.214-1.16-1.16-1.16zm-9.049-.234c-.945 0-1.16.519-1.16 1.161v.361h2.32V7.8c0-.643-.215-1.162-1.16-1.162zM9.066 11.104c0 .508.24.773.77.773.567 0 .903-.186 1.318-.376v-1.018H9.912c-.588 0-.846.11-.846.621zm35.379-4.232c-.947 0-1.275.516-1.275 1.16v2.347c0 .646.328 1.164 1.275 1.164.944 0 1.275-.518 1.275-1.164V8.032c0-.644-.33-1.16-1.275-1.16zm-40.02 6.865H1.643V6.999H.252V4.678h1.39V3.284c0-1.894.785-3.02 3.016-3.02h1.858v2.322H5.355c-.869 0-.926.324-.926.93l-.003 1.162h2.103l-.246 2.321H4.426v6.738zm9.513.017h-2.32l-.1-.587a5.318 5.318 0 0 1-2.628.682c-1.701 0-2.607-1.137-2.607-2.708 0-1.855 1.056-2.517 2.947-2.517h1.924v-.4c0-.947-.109-1.225-1.564-1.225H7.21l.233-2.321h2.601c3.194 0 3.894 1.009 3.894 3.564v5.512zm7.889-6.584c-1.444-.248-1.858-.302-2.553-.302-1.247 0-1.625.275-1.625 1.335v2.004c0 1.06.378 1.336 1.625 1.336.695 0 1.11-.056 2.553-.304v2.264c-1.265.284-2.088.358-2.785.358-2.988 0-4.176-1.571-4.176-3.841V8.393c0-2.272 1.188-3.846 4.176-3.846.697 0 1.52.075 2.785.36V7.17zm8.71 2.85h-5.104v.187c0 1.06.378 1.336 1.625 1.336 1.121 0 1.806-.056 3.247-.304v2.264c-1.39.284-2.114.358-3.478.358-2.988 0-4.177-1.571-4.177-3.841V8.16c0-1.986.882-3.613 3.944-3.613 3.063 0 3.944 1.608 3.944 3.613v1.86zm9.049.043c0 2.194-.627 3.794-4.427 3.794-1.371 0-2.176-.12-3.69-.354V.961L34.25.496v4.388c.601-.224 1.38-.337 2.088-.337 2.783 0 3.247 1.247 3.247 3.252v2.263zm8.92.047c0 1.893-.782 3.729-4.052 3.729-3.271 0-4.067-1.836-4.067-3.729V8.283c0-1.894.796-3.73 4.067-3.73 3.27 0 4.051 1.836 4.051 3.73v1.827zm8.913 0c0 1.893-.783 3.729-4.052 3.729-3.271 0-4.067-1.836-4.067-3.729V8.283c0-1.894.796-3.73 4.067-3.73 3.27 0 4.052 1.836 4.052 3.73v1.827zm9.147 3.627H63.55L61 9.478v4.259h-2.784V.96l2.783-.465v8.225l2.551-4.043h3.016L63.781 9.09l2.785 4.647zM53.358 6.872c-.945 0-1.273.516-1.273 1.16v2.347c0 .646.328 1.164 1.273 1.164.944 0 1.278-.518 1.278-1.164V8.032c0-.644-.334-1.16-1.278-1.16z"
      fill="#1977F3"
    />
  </svg>
)

export default WidgetFacebook
